import React from 'react';

interface QuickFilter {
  label: string;
  filters: {
    status?: string[];
    managerId?: string;
  };
}

interface QuickFiltersProps {
  onApply: (filters: { status?: string[]; managerId?: string }) => void;
}

const QUICK_FILTERS: QuickFilter[] = [
  {
    label: 'My Campaigns',
    filters: { managerId: 'me' },
  },
  {
    label: 'Active Campaigns',
    filters: { status: ['active'] },
  },
  {
    label: 'Paused Campaigns',
    filters: { status: ['paused'] },
  },
  {
    label: 'Unassigned',
    filters: { managerId: 'unassigned' },
  },
];

export const QuickFilters: React.FC<QuickFiltersProps> = ({ onApply }) => {
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 sm:mx-0 sm:px-0 sm:pb-0 scrollbar-thin">
      {QUICK_FILTERS.map((filter) => (
        <button
          key={filter.label}
          onClick={() => onApply(filter.filters)}
          className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 whitespace-nowrap flex-shrink-0 touch-manipulation"
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
};

QuickFilters.displayName = 'QuickFilters';
